import React from "react"

const Paragraph = ({children, paraStyles}) => {
  return (
    <p  className={`sparkle--paragraph ${paraStyles}`}>
     {children}
    </p>
  )
}
export default Paragraph
